import React, { useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Button, Grid } from "@mui/material";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import Repairreportform from './Repairreportform';
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import reportslogo from "../../assets/images/reportslogo.png";
import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

const Kpirepairdownload = forwardRef((props, ref) => {
  const { reportdata, onRenderComplete, hospitalname, service, year, setText, text, date, setDate, autoDownload, setOpenModal } = props;
  const printRef = useRef();

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA009B");

  useEffect(() => {
    if (onRenderComplete) {
      onRenderComplete();
    }
  }, [onRenderComplete]);

  useEffect(() => {
    if (autoDownload && reportdata) {
      handleDownloadPDF();
      handleExcel();
    }
  }, [reportdata, autoDownload]);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  console.log(reportdata, "REPORTDATA");

  const handleExcel = async () => {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("KPI Report");
    worksheet.columns = Array(12).fill({ width: 15 });
    const rightLogoImage = await fetch(reportslogo).then((response) =>
      response.arrayBuffer()
    );
    const rightLogoId = workbook.addImage({
      buffer: rightLogoImage,
      extension: "png",
    });
    worksheet.addImage(rightLogoId, {
      tl: { col: 0.1, row: 0.1 },
      ext: { width: 50, height: 50 },
      editAs: "oneCell",
    });
    function parsePercentage(value) {
      return typeof value === 'string' && value.includes('%')
        ? parseFloat(value.replace('%', ''))
        : parseFloat(value) || 0;
    }

    const data = [
      parsePercentage(reportdata?.perJan),
      parsePercentage(reportdata?.perFeb),
      parsePercentage(reportdata?.perMarch),
      parsePercentage(reportdata?.perApril),
      parsePercentage(reportdata?.perMay),
      parsePercentage(reportdata?.perJune),
      parsePercentage(reportdata?.perJuly),
      parsePercentage(reportdata?.perAugust),
      parsePercentage(reportdata?.perSept),
      parsePercentage(reportdata?.perOct),
      parsePercentage(reportdata?.perNov),
      parsePercentage(reportdata?.perDec)
    ];

    function calculateLinearTrendline(data) {
      const n = data.length;
      const sumX = data.reduce((acc, _, i) => acc + i, 0);
      const sumY = data.reduce((acc, y) => acc + y, 0);
      const sumXY = data.reduce((acc, y, i) => acc + i * y, 0);
      const sumXX = data.reduce((acc, _, i) => acc + i * i, 0);

      const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
      const intercept = (sumY - slope * sumX) / n;


      return resultPercentage.map((_, i) => slope * i + intercept);
    }
    const month = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const filteredData = data.filter(value => value > 0);
    const highestResultIndex = data.indexOf(Math.max(...data));
    const highestMonth = month[highestResultIndex];
    // Title Section
    worksheet.mergeCells("A1:J3");
    const titleCell = worksheet.getCell("B2");
    titleCell.value = `${hospitalname?.label}\n KEY PERFORMANCE INDICATOR - Repair Time Report`;
    titleCell.font = { size: 15, bold: true };
    titleCell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };

    // General Info Section
    worksheet.getCell("A4").value = "Service Standard";
    worksheet.getCell("B4").value = service;
    worksheet.getCell("A4").font = { bold: true };
    worksheet.getCell("A4").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("B4").alignment = { vertical: "middle", horizontal: "left" };
    [worksheet.getCell("A4")].forEach(cell => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.getCell("A5").value = "Measurable Element";
    worksheet.getCell("B5").value = "Repair time - Percentage of Repair / Work Orders completed within 7 working days";
    worksheet.getCell("A5").font = { bold: true };
    worksheet.getCell("A5").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("B5").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.mergeCells('B4:J4');
    worksheet.mergeCells('B5:J5');
    worksheet.mergeCells('B6:J6');
    worksheet.mergeCells('B7:J7');
    worksheet.mergeCells('B8:J8');
    worksheet.mergeCells('B9:J9');
    worksheet.mergeCells('B10:J10');

    ['A1', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10',].forEach(cell => {
      worksheet.getCell(cell).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
    // Adding borders to cells along with text and formatting
    const borderStyle = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

    worksheet.getCell("A6").value = "Numerator";
    worksheet.getCell("B6").value =
      `Number of repair/work orders ${year === 2026 ? "closed" : "completed"} within 7 working days as scheduled for the month`
    worksheet.getCell("A6").font = { bold: true };
    worksheet.getCell("A6").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("B6").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("A6").border = borderStyle;


    worksheet.getCell("A7").value = "Denominator";
    worksheet.getCell("B7").value = "Numbers of repair/work orders issued for the month";
    worksheet.getCell("A7").font = { bold: true };
    worksheet.getCell("A7").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("B7").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("A7").border = borderStyle;


    worksheet.getCell("A8").value = "Inclusion";
    worksheet.getCell("B8").value = "All request for repairs for facilities and equipment received and the corresponding number of work orders issued by the maintenance department for each month";
    worksheet.getCell("A8").font = { bold: true };
    worksheet.getCell("A8").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("B8").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("A8").border = borderStyle;


    worksheet.getCell("A9").value = "Exclusion";
    worksheet.getCell("B9").value = "NA";
    worksheet.getCell("A9").font = { bold: true };
    worksheet.getCell("A9").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("B9").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("A9").border = borderStyle;


    worksheet.getCell("A10").value = "Target";
    worksheet.getCell("B10").value = "7 working days";
    worksheet.getCell("A10").font = { bold: true };
    worksheet.getCell("A10").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("B10").alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getCell("A10").border = borderStyle;


    // Results Table Header
    // Merge cells for the title "RESULTS FOR THE MONTH"
    worksheet.mergeCells("A11:N11");
    worksheet.getCell("A11").value = `RESULTS FOR THE MONTH OF : YTD  ${highestMonth} ${year}`;
    worksheet.getCell("A11").alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };

    worksheet.getCell("A11").font = { size: 12, bold: true };

    // Add Table Headers (Year, Result, and Months)
    const months = [
      "Year",
      `Jan-${year}`, `Feb-${year}`, `Mar-${year}`, `Apr-${year}`, `May-${year}`, `Jun-${year}`,
      `Jul-${year}`, `Aug-${year}`, `Sep-${year}`, `Oct-${year}`, `Nov-${year}`, `Dec-${year}`, `Total`
    ];

    // Numerator Data
    const numerator = [
      "Numerator",
      ` ${reportdata?.nuJan || "0"}`,
      `${reportdata?.nuFeb || "0"}`,
      `${reportdata?.nuMarch || "0"}`,
      ` ${reportdata?.nuApril || "0"}`,
      ` ${reportdata?.nuMay || "0"}`,
      ` ${reportdata?.nuJune || "0"}`,
      ` ${reportdata?.nuJuly || "0"}`,
      ` ${reportdata?.nuAugust || "0"}`,
      ` ${reportdata?.nuSept || "0"}`,
      ` ${reportdata?.nuOct || "0"}`,
      ` ${reportdata?.nuNov || "0"}`,
      ` ${reportdata?.nuDec || "0"}`,
      ` ${reportdata?.nuTotal || "0"}`
    ];

    // Denominator Data
    const denominator = [
      "Denominator",
      ` ${reportdata?.deJan || "0"}`,
      ` ${reportdata?.deFeb || "0"}`,
      ` ${reportdata?.deMarch || "0"}`,
      ` ${reportdata?.deApril || "0"}`,
      ` ${reportdata?.deMay || "0"}`,
      ` ${reportdata?.deJune || "0"}`,
      ` ${reportdata?.deJuly || "0"}`,
      ` ${reportdata?.deAugust || "0"}`,
      ` ${reportdata?.deSept || "0"}`,
      ` ${reportdata?.deOct || "0"}`,
      ` ${reportdata?.deNov || "0"}`,
      ` ${reportdata?.deDec || "0"}`,
      ` ${reportdata?.deTotal || "0"}`
    ];

    // Result % Data
    const resultPercentage = [
      "Result %",
      ` ${reportdata?.perJan || "0"}`,
      ` ${reportdata?.perFeb || "0"}`,
      ` ${reportdata?.perMarch || "0"}`,
      ` ${reportdata?.perApril || "0"}`,
      ` ${reportdata?.perMay || "0"}`,
      ` ${reportdata?.perJune || "0"}`,
      ` ${reportdata?.perJuly || "0"}`,
      ` ${reportdata?.perAugust || "0"}`,
      ` ${reportdata?.perSept || "0"}`,
      ` ${reportdata?.perOct || "0"}`,
      ` ${reportdata?.perNov || "0"}`,
      ` ${reportdata?.perDec || "0"}`,
      ` ${reportdata?.perTotal || "0"}`
    ];

    const targetComplianceRate = [
      `Target Compliance Rate within 7 days (${year === 2025 ? "100%" : "75%"})`,
      (year === 2025 ? "100%" : "75%"), (year === 2025 ? "100%" : "75%"), (year === 2025 ? "100%" : "75%"), (year === 2025 ? "100%" : "75%"),
      (year === 2025 ? "100%" : "75%"), (year === 2025 ? "100%" : "75%"), (year === 2025 ? "100%" : "75%"), (year === 2025 ? "100%" : "75%"),
      (year === 2025 ? "100%" : "75%"), (year === 2025 ? "100%" : "75%"), (year === 2025 ? "100%" : "75%"), (year === 2025 ? "100%" : "75%"),
      (year === 2025 ? "100%" : "75%")
    ];

    /// Add Table Data to Worksheet
    worksheet.addRow(months).font = { bold: true };
    worksheet.getRow(11).alignment = { vertical: "middle", horizontal: "center" };

    // Add Results Data
    worksheet.addRow(numerator);
    worksheet.addRow(denominator);
    worksheet.addRow(resultPercentage);
    worksheet.addRow(targetComplianceRate);

    // Define the rows that should be aligned to the right
    const rows = [11, 12, 13, 14, 15]; // The rows containing the data (after header)

    // Apply cell borders and alignment for each row
    rows.forEach((rowIndex) => {
      const row = worksheet.getRow(rowIndex);
      row.eachCell((cell, colNumber) => {
        // Set borders for each cell
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        // Align specific rows to the right, including Result %
        if (rowIndex === 12 || rowIndex === 13 || rowIndex === 14 || rowIndex === 15 || rowIndex === 16) {
          cell.alignment = { vertical: "middle", horizontal: "right" }; // Align to right
        } else {
          cell.alignment = { vertical: "middle", horizontal: "center" }; // Default to center alignment
        }
      });
    });

    // Add border and alignment for the targetComplianceRate row specifically
    const targetRow = worksheet.getRow(16); // Assuming targetComplianceRate is in row 16
    targetRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = { vertical: "middle", horizontal: "right" }; // You can change this if needed
    });


    const chartCanvas = document.createElement("canvas");
    const ctx = chartCanvas.getContext("2d");

    // Extract months excluding "Year" and "Total"
    const filteredMonths = months.slice(1, -1); // Exclude the first and last elements

    // Convert result percentages to numeric values safely
    const numericResults = resultPercentage.slice(1, -1).map((val) => parseFloat(val) || 0);

    // Check if numericResults is not empty to avoid errors
    if (numericResults.length === 0) {
      console.error("No numeric results available to calculate the highest month.");
    } else {
      // Find the highest result and corresponding month
      const highestResultIndex = numericResults.indexOf(Math.max(...numericResults)); // Index of max value
      const highestMonth = filteredMonths[highestResultIndex]; // Match to month

      console.log(`Highest Month: ${highestMonth}`); // Log the result
    }

    // Error occurs here

    // Create the chart
    const chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: filteredMonths,
        datasets: [
          {
            label: "Result %",
            data: resultPercentage.slice(1, -1).map((val) => parseFloat(val) || 0),  // Exclude the first and last values
            borderColor: "rgb(75, 192, 192)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            fill: true,
          },
          {
            label: "Target",
            data: Array(12).fill(100),  // Target line at 100 for all months
            borderColor: "rgb(255, 99, 132)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            fill: true,
          },
          {
            label: 'Linear (Result)',
            data: calculateLinearTrendline(filteredData),
            borderColor: 'rgba(54, 162, 235, 1)',
            borderDash: [10, 5],
            pointRadius: 0,
            fill: false,
            tension: 0.4,
          },
        ],
      },
      options: {
        responsive: false, // Important for server-side rendering
        scales: {
          y: { beginAtZero: true },
        },
      },
    });


    // Ensure the chart is rendered properly before proceeding
    await new Promise((resolve) => setTimeout(resolve, 1000));

    // Generate chart image in base64 format
    const chartImage = chart.toBase64Image();
    const chartImageId = workbook.addImage({
      base64: chartImage.replace(/^data:image\/png;base64,/, ""),
      extension: "png",
    });

    // Add chart image to the worksheet
    worksheet.addImage(chartImageId, {
      tl: { col: 0, row: 17 }, // Top-left corner at A18 (Excel row 18)
      ext: { width: 500, height: 250 }, // Set width and height for the chart
    });

    worksheet.mergeCells("A31:D35");
    worksheet.getCell("A31").value = {
      richText: [
        { text: "Analysis:\n", font: { bold: true } },
        { text: text.analysis || "", font: { bold: false } },
      ],
    };
    worksheet.getCell("A31").alignment = { vertical: "top", horizontal: "left", wrapText: true, bold: true };

    // Set the border for the merged cells A31:D35
    worksheet.getCell("A31").border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    worksheet.getCell("A31").font = { bold: true };
    // Optionally, adjust the height of the row if needed to ensure the content is fully visible
    worksheet.getRow(31).height = 50; // Adjust this value to fit your content


    // // Merge cells and add text for the "Immediate Action Taken" section
    // Merge cells from E31 to H35 and add value to E31
    worksheet.mergeCells("E31:J35");
    worksheet.getCell("E31").value = {
      richText: [
        { text: "Immediate Action Taken:\n", font: { bold: true } },
        { text: text.immediateAction || "", font: { bold: false } },
      ],
    }
    worksheet.getCell("E31").alignment = { vertical: "top", horizontal: "left", wrapText: true, bold: true };

    // Set the border for the merged cells E31:H35
    worksheet.getCell("E31").border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    worksheet.getCell("E31").font = { bold: true };
    worksheet.getRow(31).height = 50; // Adjust this value to fit your content


    worksheet.mergeCells("A36:D39");
    worksheet.getCell("A36").value = {
      richText: [
        { text: "Quality Improvement Activities:\n", font: { bold: true } },
        { text: text.qualityImprovement || "", font: { bold: false } },
      ],
    };

    worksheet.getCell("A36").alignment = { vertical: "top", horizontal: "left", wrapText: true, bold: true };
    worksheet.getCell("A36").border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    worksheet.getCell("A36").font = { bold: true };

    // worksheet.getCell("E40").value = `
    // Prepared by:                 Reviewed by:                  Approved by:
    // Name:                         Name:                         Name: 
    // Designation:                  Designation:                  Designation: 
    // Date:                         Date:                         Date: 
    // `;

    // worksheet.getCell("E40").alignment = { vertical: "top", horizontal: "left", wrapText: true };


    // worksheet.getCell("E40").border = {
    //   top: { style: 'thin' },
    //   left: { style: 'thin' },
    //   bottom: { style: 'thin' },
    //   right: { style: 'thin' },
    // };
    // worksheet.mergeCells("A36:D36"); // Merge cells for 'Quality Improvement Activities'
    // worksheet.getCell("A36").value = "Quality Improvement Activities:";
    // worksheet.getCell("A36").alignment = { vertical: "middle", horizontal: "left", wrapText: true };

    // worksheet.getCell("A36").border = {
    //   top: { style: 'thin' },
    //   left: { style: 'thin' },
    //   bottom: { style: 'thin' },
    //   right: { style: 'thin' },
    // };

    // Merge cells for 'Prepared by:', 'Reviewed by:', and 'Approved by:'
    worksheet.mergeCells("E36:F36");
    worksheet.getCell("E36").value = "Prepared by:";
    worksheet.getCell("E36").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("E36").border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    worksheet.getCell("E36").font = { bold: true };
    worksheet.mergeCells("G36:H36");
    worksheet.getCell("G36").value = "Reviewed by:";
    worksheet.getCell("G36").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("G36").border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    worksheet.getCell("G36").font = { bold: true };
    worksheet.mergeCells("I36:J36");
    worksheet.getCell("I36").value = "Approved by:";
    worksheet.getCell("I36").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("I36").border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    worksheet.getCell("J36").border = {
      top: { style: 'thin' },
      right: { style: 'thin' }, // Added the right border for the "Approved by:" section
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

    worksheet.getCell("I36").font = { bold: true };
    // Adjust the text in cells for Name, Designation, and Date (under each section)
    worksheet.mergeCells("E37:F37");
    worksheet.getCell("E37").value = {
      richText: [
        { text: "Name:", font: { bold: true } },
        { text: date.name || " ", font: { bold: false } },
      ],
    };
    worksheet.getCell("E37").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("E37").border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } };

    worksheet.mergeCells("E38:F38");
    worksheet.getCell("E38").value = {
      richText: [
        { text: "Designation:", font: { bold: true } },
        { text: date.designation || " ", font: { bold: false } },
      ],
    };
    worksheet.getCell("E38").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("E38").border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } };

    worksheet.mergeCells("E39:F39");
    worksheet.getCell("E39").value = {
      richText: [
        { text: "Date:", font: { bold: true } },
        { text: date.date || " ", font: { bold: false } },
      ],
    };
    worksheet.getCell("E39").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("E39").border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' }, };

    // For Reviewed by:
    worksheet.mergeCells("G37:H37");
    worksheet.getCell("G37").value = {
      richText: [
        { text: "Name:", font: { bold: true } },
        { text: date.names || " ", font: { bold: false } },
      ],
    };
    worksheet.getCell("G37").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("G37").border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    worksheet.mergeCells("G38:H38");
    worksheet.getCell("G38").value = {
      richText: [
        { text: "Designation:", font: { bold: true } },
        { text: date.designations || " ", font: { bold: false } },
      ],
    };
    worksheet.getCell("G38").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("G38").border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    worksheet.mergeCells("G39:H39");
    worksheet.getCell("G39").value = {
      richText: [
        { text: "Date:", font: { bold: true } },
        { text: date.dates || " ", font: { bold: false } },
      ],
    };
    worksheet.getCell("G39").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("G39").border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    // For Approved by:
    worksheet.mergeCells("I37:J37");
    worksheet.getCell("I37").value = {
      richText: [
        { text: "Name:", font: { bold: true } },
        { text: date.nam || " ", font: { bold: false } },
      ],
    };
    worksheet.getCell("I37").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("I37").border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    worksheet.mergeCells("I38:J38");
    worksheet.getCell("I38").value = {
      richText: [
        { text: "Designation:", font: { bold: true } },
        { text: date.designatio || " ", font: { bold: false } },
      ],
    };
    worksheet.getCell("I38").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("I38").border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    worksheet.mergeCells("I39:J39");
    worksheet.getCell("I39").value = {
      richText: [
        { text: "Date:", font: { bold: true } },
        { text: date.dat || " ", font: { bold: false } },
      ],
    };
    worksheet.getCell("I39").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    worksheet.getCell("I39").border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };



    // Save the workbook
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), "KPI Repair_Report.xlsx");
      console.log("File saved successfully");
    } catch (error) {
      console.error("Error while saving Excel file:", error);
    }

  };






  const handleDownloadPDF = () => {

    html2canvas(printRef.current, {
      scale: 2,
      useCORS: true,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
      });

      const pdfWidth = 200;
      const pdfHeight = 297;


      const imgWidth = canvas.width * 0.264583;
      const imgHeight = canvas.height * 0.264583;
      const scale = pdfWidth / imgWidth;


      const width = imgWidth * scale;
      const height = imgHeight * scale;


      const finalHeight = height > pdfHeight ? pdfHeight : height;


      const x = 5;
      const y = (pdfHeight - finalHeight) / 2;

      pdf.addImage(imgData, 'PNG', x, y, width, finalHeight);
      pdf.save("KPI Repair Time Report.pdf");
    }).catch(error => {
      console.error("Error generating PDF:", error);
    });
  };


  const handleClose = () => {
    setOpenModal(false);
  };

  useImperativeHandle(ref, () => ({
    handleDownloadPDF,
    handleExcel,
  }));

  return (
    <>
      <Grid container justifyContent="flex-end">

        {access?.canPrint && (<>
          <Grid item>
            <Button variant="contained" onClick={handlePrint} style={{ marginRight: '8px' }}>Print</Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              onClick={handleDownloadPDF}
              startIcon={<DownloadIcon />}
              style={{ marginRight: '8px' }}
            >
              Download
            </Button>
          </Grid>
        </>)}
        <Grid item>
          <Button
            variant="contained"
            onClick={handleExcel}
            startIcon={<InsertDriveFileIcon />}
            style={{ marginRight: '8px' }}
          >
            Excel
          </Button>
        </Grid>

        <Grid item>
          <Button variant="contained" onClick={handleClose}>Close</Button>
        </Grid>
      </Grid>
      <Repairreportform
        ref={printRef}
        year={year}
        hospitalname={hospitalname}
        reportdata={reportdata}
        service={service}
        setText={setText}
        text={text}
        setDate={setDate}
        date={date}
        className="pdf-content"
      />
    </>
  );
});

export default Kpirepairdownload;
